import { render } from "./VODEmbedTab.vue?vue&type=template&id=d1d165fa"
import script from "./VODEmbedTab.vue?vue&type=script&setup=true&lang=js"
export * from "./VODEmbedTab.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/VOD/VODEmbedTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d1d165fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d1d165fa', __exports__)) {
    api.reload('d1d165fa', __exports__)
  }
  
  module.hot.accept("./VODEmbedTab.vue?vue&type=template&id=d1d165fa", () => {
    api.rerender('d1d165fa', render)
  })

}


export default __exports__